import React, { useState, useEffect } from "react";
import "mdb-ui-kit/css/mdb.min.css";

import "./Styles/UserForm.css";



export default function ViewUserBranch(props) {
  const [object, setObject] = useState(props.object)
  useEffect(() => {
    setObject(props.object)
  }, [props.object]);


  return (
    <div
      className={`ModalFormContainer rounded-3 px-2 ${
        props.inactive === false ? "activeSideMenu" : ""
      }`}
    >
      {/* header of form section  */}
      <div className="container-lg py-4 px-2 ">
        <div className="row">
          <div className="col-md-12 ">
            <div className="toSection d-flex justify-content-center align-items-center">
              <span className="FormName">اسم الفرع</span>
            </div>
          </div>
          <div className="col-md-12 ">
            <div className="toSection d-flex justify-content-center align-items-center">
              <span className="FormName">{object.name}</span>
            </div>
          </div>
        </div>
      </div>

     
     
    </div>
  );
}
